// import { NetworkType } from 'nem2-sdk';

export interface INetwork {
  networkid: any;
  endpoints: string[];
}

export interface IBlockchainConfig {
  mijin_test: INetwork;
  luxtag_consortium: INetwork;
  moe_consortium: INetwork;
}

const blockchainConfig: IBlockchainConfig = {
  mijin_test: {
    networkid: 'NetworkType.MIJIN_TEST',
    endpoints: [
      'http://api.beta.catapult.mijin.io:3000'
    ]
  },
  luxtag_consortium: {
    networkid: 'NetworkType.MIJIN_TEST',
    endpoints: []
  },
  moe_consortium: {
    networkid: 'NetworkType.MIJIN_TEST',
    endpoints: []
  }
};

export default blockchainConfig;
